<template>
  <div id="app">
    <Header/>
    <div id="body">
      <router-view/>
    </div>
    <div>
      <Contact/>
    </div>
  </div>
</template>

<script>
import Header from './components2/Header'
import Contact from './components2/Contact'
import Footer from './components2/Footer'

export default {
  name: 'App',
  components: {Header, Contact, Footer}
}
</script>

<style>
html, body {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  margin: 0;
  padding: 0;
}

#app {
  display: flex;
  flex-direction: column;
  font-family: 'Lato', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 24px;
  font-weight: 300;
  line-height: 1.5;
  letter-spacing: 0.05em;
  min-height: 100vh; /* 保证占满屏幕高度 */
}

#body {

  flex: 1;
}

#contact-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white; /* 可根据需要调整背景色 */
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* 添加一个阴影效果 */
  z-index: 1000; /* 确保层级较高，不被其他内容遮挡 */
}

@media (max-width: 1200px) {
  #app {
    width: 100%;
    font-size: 18px;
  }

  #body {
    margin-left: 5%;
    margin-right: 5%;
  }
}

@media (max-width: 768px) {
  #app {
    width: 100%;
    font-size: 16px;
  }

  #body {
    margin-left: 3%;
    margin-right: 3%;
  }

  #Contact {
    width: 100%;
    font-size: 14px;
  }
}

@media (max-width: 390px) {
  #app {
    width: 100%;
    font-size: 14px;
  }

  #body {
    margin-left: 2%;
    margin-right: 2%;
  }

  #Contact {
    width: 390px;
    /* width: 100%; */
    font-size: 12px;

  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue